<template>
  <div>
    <data-table :service="EmailTemplateService"
                :entity="entity"
                :columns="columns"
                :disablePermissionChecks="true"
                operations="edit"
                ref="table">
      <template v-slot:subject="{row}">
        {{row.subject}}
      </template>
      <template v-slot:placeholders="{row}">
        <badge v-for="placeholder in row.placeholders"
               :key="placeholder.name"
               class="mr-1 mb-1 placeholder-badge"
               type="info">
          <span>{{placeholder.description}}</span>
        </badge>
      </template>
    </data-table>
  </div>
</template>
<script>
  import EmailTemplateService from 'src/services/EmailTemplateService';
  import entities from 'src/config/entities';
  import Badge from 'src/components/Badge'

  export default {
    name: 'email-template-list',
    components: {
      Badge,
    },
    data() {
      return {
        EmailTemplateService,
        entity: entities.EMAIL
      }
    },
    computed: {
      columns() {
        return  [
          {
            prop: "subject",
            label: this.$t('client.list.labels.name'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "placeholders",
            label: this.$t('generic.placeholders'),
            minWidth: "150px",
            sortable: true
          }
        ]
      }
    }
  }
</script>
<style scoped>
  .placeholder-badge {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
